// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1tfIa","imageUploader":"EGiftCard_imageUploader__s3lMB"};